/**
 * @desc 公共filters
 */

import Vue from 'vue'
import address from '*/address.config'

// 过滤器数组
const filters = {
  // 找到匹配的字符串并包裹span标签
  findStrWrapSpan(str, findStr) {
    if (str && findStr) {
      let reg = RegExp(findStr, 'i')
      if (str.match(reg)) {
        return str.replace(reg, `<span>${str.match(reg)[0]}</span>`)
      } else {
        return str
      }
    }
  },
  // 图片拼接cdn过滤器
  imgCdn(val) {
    return address.IMG_ADDRESS + val
  },
  // 字符串截取过滤器
  cutStr(str = '', L = 8) {
    if (!(typeof str === 'string') || !str) {
      return ''
    }
    let result = ''
    const strlen = str.length // 字符串长度
    const chrlen = str.replace(/[^\x00-\xff]/g, '**').length // 字节长度
    if (chrlen <= L) {
      return str
    }

    for (let i = 0, j = 0; i < strlen; i++) {
      const chr = str.charAt(i)
      if (/[\x00-\xff]/.test(chr)) {
        j++ // ascii码为0-255，一个字符就是一个字节的长度
      } else {
        j += 2 // ascii码为0-255 以外，一个字符就是两个字节的长度
      }
      if (j <= L) {
        // 当加上当前字符以后，如果总字节长度小于等于L，则将当前字符真实的+在result后
        result += chr
      } else {
        // 反之则说明result已经是不拆分字符的情况下最接近L的值了，直接返回
        const strItem = result.trim().split(' ')
        if (strItem.length > 1) {
          strItem.pop()
        }
        result = strItem.join(' ')
        return `${result}...`
      }
    }
  },
  // 过滤侧边栏数据切换国际化语言
  isMainFilter(isMain, te) {
    switch (isMain) {
      case "收件箱":
        return te('email.inbox')
      case "Drafts":
        return te('email.drafts')
      case "Sent Items":
        return te('email.sentItems')
      case "Deleted Items":
        return te('email.deletedItems')
      case "Junk Email":
        return te('email.junkEmail')
    }
  },
  // 过滤邮件内容
  filterEmailHtml(emailHtml) {
    let styleRE = /<style(([\s\S])*?)<\/style>/g
    let zindexRE = /z-index:/g
    if (!emailHtml) return
    let temp = ""
    // 过滤掉style标签
    temp = emailHtml.replace(styleRE, "")
    // 将z-index:样式置为无效
    temp = temp.replace(zindexRE, "_z-index:")
    //浏览器本地存储的邮件详情可能包含过期的token，替换为本地存储的有效token
    let reg = /\/emails\/attachments\/id\?token=([^\s\t\r\n""'<>]*)&id=/,
      oldTokenT = temp.match(reg)
    if (oldTokenT) {
      // let oldToken = oldTokenT[1],
      //   newToken = localStorage.geelyToken,
      //   regToken = new RegExp(oldToken, "g") //全文匹配
      // temp = temp.replace(regToken, newToken)
      // temp = temp.replaceAll(oldTokenT[0], `${address.API_ADDRESS}${oldTokenT[0]}`)
      temp = temp.replaceAll(oldTokenT[0], `/api${oldTokenT[0]}`)
      console.log(temp)
    }
    return temp
  },
  //转换文件大小
  transformKB(limit) {
    if (typeof limit === "number") {
      var size = ""
      if (limit < 0.1 * 1024) {
        //如果小于0.1KB转化成B
        size = limit.toFixed(2) + "B"
      } else if (limit < 0.1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        size = (limit / 1024).toFixed(2) + "KB"
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
      } else {
        //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
      }
      var sizestr = size + ""
      var len = sizestr.indexOf(".")
      var dec = sizestr.substr(len + 1, 2)
      if (dec == "00") {
        //当小数点后为00时 去掉小数部分
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
      }
      return sizestr
    } else {
      return limit
    }
  },
  sidebarData(v) {
    if (v === '收件箱') {
      return '收件箱'
    } else if (v === 'Drafts' || v === "草稿箱") {
      return '草稿箱'
    } else if (v === 'Sent Items' || v === "已发送") {
      return '已发送'
    } else if (v === 'Deleted Items' || v === "已删除") {
      return '已删除'
    } else if (v === 'Junk Email' || v === "垃圾邮件") {
      return '垃圾邮件'
    } else {
      return v
    }
  },
  searchData(vla, te) {
    if (vla === "全部") {
      return te('email.all')
    } else if (vla === "主题") {
      return te('email.subject')
    } else if (vla === "收件人") {
      return te('email.to')
    } else if (vla === "发件人") {
      return te('email.addressor')
    }
  }
}

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))
Vue.prototype.$filters = filters

export default filters
